'use client';

import dynamic from 'next/dynamic';

//* Components
import Page from '@/components/global/Page';
import HeroSection from '@/components/sections/HeroSection';

const ServicesListing = dynamic(() => import('./components/ServicesListing'), { ssr: false });
const OtherSection = dynamic(() => import('../digital-practices/components/Sections/Item'));
const GetItTouchSection = dynamic(() => import('@/components/sections/GetItTouchSection'), { ssr: false });
const FAQSection = dynamic(() => import('@/components/sections/FAQSection'), { ssr: false })

//* Style
import ServicesPageStyle from '@/styles/pages/ServicesPageStyle';

export default function ServicesTemplate({ pageData }) {
    return (
        <Page className={'services'}>
            <ServicesPageStyle>
                <HeroSection {...pageData.data.hero} />

                <ServicesListing
                    {...pageData.data.info}
                    data={pageData.data.services}
                />

                <OtherSection {...pageData.data.other} />

                <GetItTouchSection isDark />

                <FAQSection />
            </ServicesPageStyle>
        </Page>
    );
}
